_ = require 'underscore'
$ = require 'jquery'
AddTagView = require 'views/organization/add-tag-view'
Auth = require 'db/auth'
BoardListItemComponent = require 'views/board-list/board-list-item-component'
BoardListItemAddComponent = require 'views/board-list/board-list-item-add-component'
BoardListItemBadgeComponent = require 'views/badges/board-list-item-badge-component'
BoardListItemTagAddComponent = require 'views/board-list/board-list-item-tag-add-component'
BoardListSectionComponent = require 'views/board-list/board-list-section-component'
BoardTagSelectView = require 'views/organization/board-tag-select-view'
BoardDisplayHelpers = require 'views/internal/board-display-helpers'
CreateBoardComponent = require 'views/board-create/create-board-component'
Dates = require 'lib/dates'
OrganizationBoardsComponent = require './organization-boards-component'
OrganizationView = require 'views/organization/organization-view'
Controller = require 'controller'
Dialog = require 'views/lib/dialog'
PopOver = require 'views/lib/pop-over'
React = require 'react'
ReactDOM = require 'react-dom'
createBoardHelpers = require 'views/board-create/helpers'
ReactRootComponent = require 'views/internal/react-root-component'
getExperiment = require 'lib/experiments/simple-test'
Storage = require 'lib/storage'
Util = require 'lib/util'
template = require 'views/templates/org_bc_intro'
l = require 'lib/localize'
f = require 'effing'
track = require 'debug/track'
t = require('views/internal/recup-with-helpers')('org_filtering')
formatNumber = require 'lib/format/number'
xtend = require 'xtend'
moment = require 'moment'

module.exports = class OrganizationBoardsView extends OrganizationView

  initialize: ->
    super

    track('Organization Boards Page', 'Open')
    @listenTo @model, 'change', @renderReactSection

    @listenTo @model.boardList, 'change:idTags change:name', @renderReactSection

    @listenTo @model.tagList, 'add remove reset change', @renderReactSection

    @listenTo Auth.me().boardStarList, 'add remove reset',
      @frameDebounce @renderReactSection

    @listenTo Auth.me(),
      'change:messagesDismissed', @frameDebounce @renderReactSection

    return

  events:
    'click .js-close-intro-helper': 'closeBCIntro'

  isFullWidth: -> !Auth.me().isAdDismissed('collection-features')  || @model.isFeatureEnabled('tags')

  boardToModelForBoardItem: (board) ->
    props =
      id: board.id
      name: board.get('name')
      idTags: board.getIdTags()
      isOtherPrivate:
        !Auth.me().boardList.get(board.id)? &&
        board.getPref('permissionLevel') == 'private'
      membershipCount: board.getMembershipCount()
      starCount: board.getStarCount('organization')
      dateLastActivity: new Date(board.get('dateLastActivity') ? Util.idToDate(board.id))
      background: @backgroundObjForBoard(board)
      showOptions: Auth.isLoggedIn()
      isStarred: Auth.me().boardStarList.getBoardStar(board.id)?
      relUrl: board.getUrl()
      onStarClick: (idBoard) =>
        boardStarList = Auth.me().boardStarList
        if !boardStarList.getBoardStar(idBoard)?
          boardStarList.starBoard(idBoard)
          track('Organization View', 'Star Board')
        else
          boardStarList.unstarBoard(idBoard)
          track('Organization View', 'Unstar Board')
        return
      badgeComponents: if @model.isFeatureEnabled('tags') then @badgeComponentsForBoard(board) else []
      key: board.id
      onBoardClick: ->
        track('Organization View', 'Boards Page', 'Click on Board')

    props

  boardToModelForBoardItemWithTags: (board) ->
    xtend @boardToModelForBoardItem(board),
      tags: @tagsForBoard(board)
      extraTagComponents:
        [React.createElement(BoardListItemTagAddComponent, onClick: @addTagToBoard.bind(@, board), key: board.id, id: board.id)]

  boardToModelForBoardItemWithNoTags: (board) ->
    xtend @boardToModelForBoardItem(board),
      tagComponents: []

  backgroundObjForBoard: (board) ->
    _.extend brightness: board.getPref('backgroundBrightness'),
      if board.getPref('backgroundTile')
        image: board.getPref('backgroundImage')
        tiled: true
      else if preview = Util.smallestPreviewBiggerThan(board.getPref('backgroundImageScaled'), 400, 200)?.url ? board.getPref('backgroundImage')
        image: preview
        tiled: false
      else
        color: board.getPref('backgroundColor') ? board.getClientBackgroundColor('blue')

  tagsForBoard: (board) ->
    @model.tagList.models
    .filter (tag) ->
      tag.id in board.getIdTags()
    .map (tag) ->
      id: tag.id
      name: tag.get('name')

  storedTagsCleanup: (orgTags) ->
    savedFilter = Storage.get(@localStorageKey())
    tagFilter = savedFilter?.tagFilter

    if !tagFilter || tagFilter in _.map(orgTags, (tag) -> tag.id)
      return

    savedFilter.tagFilter = null
    Storage.set(@localStorageKey(), savedFilter)

  addTagToBoard: (board, el) ->
    track("Organization View", "Boards Page", "Open Tag Select Menu")
    PopOver.toggle
      elem: el
      view: BoardTagSelectView
      options:
        model: board
        org: @model
        modelCache: @modelCache
        isGhost: @isGhost()

  badgeComponentsForBoard: (board) ->
    starCount = board.getStarCount('organization')
    memberCount = board.getMembershipCount()
    dateLastActive = board.get('dateLastActivity') ? Util.idToDate(board.id)
    visIcon = BoardDisplayHelpers.getPermLevelIconClassForBoard(board)
    visTitleText = BoardDisplayHelpers.getPermLevelAltTextForBoard(board)

    _.compact [
      React.createElement BoardListItemBadgeComponent,
        icon: visIcon
        title: visTitleText
        iconClass: 'is-vis-color'
        key: ['vis', board.id].join('-')
      React.createElement BoardListItemBadgeComponent,
        icon: 'member'
        text: formatNumber(memberCount)
        title: t.l 'members'
        key: ['member', board.id].join('-')
      if starCount then React.createElement BoardListItemBadgeComponent,
        icon: 'star'
        text: formatNumber(starCount)
        title: t.l 'members-who-starred-board'
        key: ['star', board.id].join('-')
      React.createElement BoardListItemBadgeComponent,
        icon: 'activity'
        text: Dates.toDateString(dateLastActive)
        title: t.l 'last-activity'
        key: ['activity', board.id].join('-')
    ]

  renderMainContent: ->
    isBusinessClassAdmin = @model.isPremium() and @model.owned()

    @$('.js-content').empty()

    if isBusinessClassAdmin && !Auth.me().isDismissed("BCIntro-#{@model.id}")
      @$('.js-content').append(
        template({
          isEnterprise: @model.belongsToRealEnterprise()
          hasCSVExport: @model.isFeatureEnabled('csvExport')
          hasGoldMembers: @model.isFeatureEnabled('goldMembers')
        })
      )

    @$reactRoot ?= $('<div></div>')
    @$('.js-content').append(@$reactRoot)
    @renderReactSection()

    @setActiveView('.js-org-profile')

    @

  renderReactSection: ->
    ReactDOM.render(@getReactRoot(), @$reactRoot[0])

    @

  localStorageKey: -> "orgFilteringState-#{ @model.id }"

  saveFilter: (filter) ->
    Storage.set(@localStorageKey(), filter)

  getReactRoot: ->
    React.createElement ReactRootComponent, {},
      if @model.isFeatureEnabled('tags')
        @getFilterableBoardsComponent()
      else
        @getBoardsComponent()

  isGhost: ->
    inviteToken = Util.inviteTokenFor(@model.id)
    inviteToken? && @modelCache.get('Member', inviteToken.split('-')[0])?

  getFilterableBoardsComponent: ->

    props =
      key: @model.id
      id: @model.id
      tags: @model.tagList.toJSON()
      boards: @getBoardItemsWithTags()
      newBoard:
        if Auth.me().canAddBoardsTo(@model)
          @newBoard.bind(@)
      preloadCreateBoardData: f(@, 'preloadCreateBoardData')
      addTag: f(@, 'addTag')
      onFilterChange: f(@, 'saveFilter')
      initialFilterState: Storage.get(@localStorageKey())
      isGhost: @isGhost()

    React.createElement OrganizationBoardsComponent, props

  getBoardsComponent: ->
    me = Auth.me()
    isAdDismissed = me.isAdDismissed('collection-features')

    props =
      billingUrl: Controller.getOrganizationBillingUrl(@model)
      showAd: !isAdDismissed
      isAdDismissed: isAdDismissed
      dismissAd: me.dismissAd.bind(me, 'collection-features')
      items: @getBoardItemsWithNoTags().map f.choke(1, React, 'createElement', BoardListItemComponent)

    if Auth.me().canAddBoardsTo(@model)
      props.createNewItem = React.createElement BoardListItemAddComponent,
        newBoard: f(@, 'newBoard')
        preloadData: f(@, 'preloadCreateBoardData')

    React.createElement BoardListSectionComponent, props

  addTag: (el) ->
    track("Organization View", "Boards Page", "Open Create Tag Menu")
    PopOver.toggle
      elem: el
      view: AddTagView
      options:
        model: @model
        modelCache: @modelCache

  preloadCreateBoardData: ->
    createBoardHelpers.preloadData()

  newBoard: (el) ->
    track("Organization View", "Boards Page", "Open Create Board Menu")

    Dialog.show
      displayType: 'mod-no-chrome'
      opacity: 0.75
      reactElement: React.createElement CreateBoardComponent,
        defaultOrg: @model
        trackingOpts: { category: 'team', method: 'by clicking create new board button in boards tab' }


  getVisibleBoards: ->
    @model.boardList.models
    .filter (board) -> board.isOpen()

  getBoardItemsWithTags: ->
    @getVisibleBoards()
    .map f(@, 'boardToModelForBoardItemWithTags')

  getBoardItemsWithNoTags: ->
    @getVisibleBoards()
    .map f(@, 'boardToModelForBoardItemWithNoTags')

  remove: ->
    ReactDOM.unmountComponentAtNode(@$reactRoot[0])
    super

  closeBCIntro: ->
    Auth.me().dismiss("BCIntro-#{@model.id}")
    track("Organization View", "Profile Page", "Dismiss BC Intro Helper")
    @renderMainContent()
    Util.scrollToTop()

    return



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-boards-view.coffee